import { Field, Form, Formik } from 'formik';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import DayPicker from 'react-day-picker';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import _actions from '../actions';
import DismissableAlert from '../components/common/DismissableAlert';
import ExpiredPackages from '../components/common/ExpiredPackages';
import { FormFieldWrapper } from '../components/common/FormFieldWrapper';
import { FormHeader } from '../components/common/FormHeader';
import { FormSubheader } from '../components/common/FormSubheader';
import { FormSubmit } from '../components/common/FormSubmit';
import { FormSubmitButton } from '../components/common/FormSubmitButton';
import { FormWrapper } from '../components/common/FormWrapper';
// day picker style in main scss import
import { getDay, isEmptyDate, parseISOLocal } from '../utils/date';
import daySkipped from '../utils/daySkipped';
import getMaxDate from '../utils/getMaxDate';
import getMinDate from '../utils/getMinDate';
import './Date.scss';

class DateContainer extends Component {
  componentDidMount() {
    const { done, actions, config } = this.props;

    if (daySkipped(config)) {
      var maxDate = getMaxDate(config);

      actions.updateSale({
        day: getDay(maxDate || new Date())
      });
      actions.transitionTo('/package');
      return;
    }

    if (done) {
      actions.transitionTo('/thanks');
      return;
    }
  }

  render() {
    const { error, loading, actions, sale, config } = this.props;

    return (
      <FormWrapper>
        <FormHeader>Buy Tickets: Select Date</FormHeader>
        <FormSubheader>
          <ExpiredPackages sale={sale} actions={actions} />
        </FormSubheader>
        <Formik
          initialValues={{
            day: sale.day || getDay(getMinDate(config))
          }}
          validate={() => {
            let errors = {};
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            this.setState({ touched: false }, () => {
              actions.updateSale(values);
              setSubmitting(false);
              actions.startSale().then(() => {
                actions.transitionTo('/package');
              });
            });
          }}
        >
          {({ isSubmitting, setFieldValue }) => {
            const disabled = isSubmitting || loading;
            return (
              <Form>
                <FormFieldWrapper
                  name="day"
                  label="Select a Date"
                  type="calendar"
                  list
                  required
                >
                  <Field
                    name="day"
                    render={({ field }) => {
                      const selectedDay = isEmptyDate(field.value)
                        ? null
                        : parseISOLocal(field.value);
                      const minDate = getMinDate(config);
                      const maxDate = getMaxDate(config);
                      return (
                        <DayPicker
                          onDayClick={(day, modifiers) => {
                            if (modifiers.disabled) {
                              return;
                            }
                            setFieldValue(field.name, getDay(day));
                          }}
                          selectedDays={selectedDay}
                          disabledDays={{ before: minDate, after: maxDate }}
                          fromMonth={minDate}
                          month={selectedDay || minDate}
                        />
                      );
                    }}
                  />
                </FormFieldWrapper>
                <FormSubmit>
                  <FormSubmitButton disabled={disabled}>
                    Continue
                    {disabled ? (
                      <span>
                        &nbsp;
                        <i className="fa fa-spinner fa-pulse" />
                      </span>
                    ) : (
                      ''
                    )}
                  </FormSubmitButton>
                </FormSubmit>
              </Form>
            );
          }}
        </Formik>

        <DismissableAlert>{error}</DismissableAlert>
      </FormWrapper>
    );
  }
}

DateContainer.propTypes = {
  actions: PropTypes.object,
  error: PropTypes.string,
  config: PropTypes.object,
  loading: PropTypes.bool,
  sale: PropTypes.object,
  inventory: PropTypes.object,
  done: PropTypes.bool
};

const mapStateToProps = state => ({
  ...state.sale,
  config: state.config,
  inventory: state.inventory
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(_actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(DateContainer));
